import { useState } from 'react';
import { useRouter } from 'next/router';

const CategoriesItems = ({ categoryList, onChange }) => {
  const [checkedItems, setCheckedItems] = useState(null);
  const { query: { category } } = useRouter();

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    if (checked) {
      setCheckedItems(id);
      onChange(id);
    } else {
      setCheckedItems(null);
      onChange(null);
    }
  };
  return (
    <>
      {categoryList?.map((item) => {
        const data = item.attributes;
        return (
          <li key={data.post_category_slug}>
            <label className='flex items-center cursor-pointer w-full'>
              <input
                type='checkbox'
                id={data.post_category_slug}
                className='h-5 w-5 mr-3 rounded border-jacarta-200 text-accent checked:bg-accent focus:ring-accent/20 focus:ring-offset-0 dark:border-jacarta-500 dark:bg-jacarta-600'
                checked={checkedItems === data.post_category_slug || category === data.post_category_slug}
                onChange={(event) => handleCheckboxChange(event)}
              />
              <span className='font-display text-sm font-semibold text-jacarta-700 dark:text-white'>
              {data.post_category_name}
            </span>
            </label>
          </li>
        );
      })}
    </>
  );
};

export default CategoriesItems;
